import uiReducer from './ui.js'
import userReducer from './user.js'
import storiesReducer from './stories.js'
import accountsReducer from './accounts.js'
import adventuresReducer from './adventures.js'
import toastsReducer from './toasts.js'
import exportsReducer from './exports.js'
import {routerReducer} from 'react-router-redux'

export default {
  ui:uiReducer,
  user:userReducer,
  toasts:toastsReducer,
  router:routerReducer,
  stories:storiesReducer,
  accounts:accountsReducer,
  exports:exportsReducer,
  adventures:adventuresReducer
}



// WEBPACK FOOTER //
// ./src/utils/reducers/index.js